/**
 * Main entrypoint for theme scripts that should be loaded on every page.
 */

import jQuery from 'jquery';
import { applyToggleExpanded } from './theme/toggle-expanded';
import { applyQuicklinks } from './theme/quicklinks';
import './theme/alert';

/**
 * Make our menu toggle buttons expand the element defined in its aria-controls
 * attribute.
 *
 * A second argument can be passed to specify options, such as
 * `clickOutsideClose`, which can turn off the close behavior when clicking
 * outside the target element.
 *
 * This can be used for any other toggle button that expands any element, for
 * example, an FAQ section.
 */
applyToggleExpanded( 'main-navigation' );
applyToggleExpanded( 'main-search' );
applyToggleExpanded( 'site-gov-banner-content', { clickOutsideClose: false } );

applyQuicklinks( '.site-quicklinks' );

// Legacy Officials bio popup.
(function ($) {

	if($(".official-featherlight").length > 0){
		$(".official-featherlight").each(function(index, el) {
			var featherlightContent = $(el).attr('data-featherlight-target');
			$(el).on('click',function(evt){
				var modal = $.featherlight($(featherlightContent));
				window.modal = modal;
				modal.beforeContent = function(){
					$('.featherlight').addClass('featherlight-officials');
				}
				modal.open();
			})
		});
	}

	if($('.wp-block-lakecountyohio-news-cards__slide').length > 0){

		console.log('found slides! must sort!')
		
		// Select all elements with the class 'wp-block-lakecountyohio-news-cards__slide'
		const cardElements = document.querySelectorAll('.wp-block-lakecountyohio-news-cards__slide');

		// Convert NodeList to an array for sorting
		const cardArray = Array.from(cardElements);

		// Custom sort function based on tag-date
		const customSort = (a, b) => {
		    // Extract the date strings from the tag-date elements
		    const dateA = new Date(a.querySelector('.tag-date__date time').getAttribute('datetime'));
		    const dateB = new Date(b.querySelector('.tag-date__date time').getAttribute('datetime'));
		    
		    // Compare the dates
		    return dateB - dateA; // Change to dateA - dateB for ascending order
		};

		// Sort the array based on the custom sort function
		cardArray.sort(customSort);

		// Remove existing elements
		cardElements.forEach(card => card.remove());

		// Append sorted elements back to the parent container
		const cardContainer = document.querySelector('.wp-block-lakecountyohio-news-cards__cards');
		cardArray.forEach(card => cardContainer.appendChild(card));

	}
})(jQuery);
